import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import ScrollLoader from 'Components/scroll-loader'
import Loading from 'Components/loading'
import getUrl from 'lib/url'
import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  createContext,
  useMemo,
} from 'react'
import ArticleCard, { RawData } from 'Components/ugc/article-card'
import { GlobalStoreContext } from 'Components/store'
import Button from 'Components/button'
import Modal from 'Components/modal'
import Publisher, { IPB } from 'Components/publisher/publisher'
import { mockNewCard } from 'lib/mock-new-card'
import { CloseIconForPublisher } from 'Components/publisher/close-icon'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import fetch from 'lib/decorated-fetch'
import useLoginCheckCallback from 'Components/hooks/use-login-check-callback'
const publish_icon = require('static/publish@3x.png')

const publicParams = {
  device_platform: 'android',
  aid: '1839',
  version_code: '608',
  impression_info: {
    page_id: 'page_forum_tab',
    sub_tab: 'motor_car_cmg',
  },
}

export const FeedContext = createContext<{
  onDeletePost: ((gid: string) => void) | undefined
    }>({
      onDeletePost: undefined,
    })

const renderCards = (list: RawData[]) => (
  <>
    {list.map((e, index) => (
      <div className="feed-item" key={e.unique_id_str + index}>
        <ArticleCard {...e} />
        <style jsx>
          {`
            .feed-item {
              width: 800px;
              border-radius: 2px;
              background-color: white;
              margin-bottom: 8px;
              padding: 24px;
              position: relative;
            }
          `}
        </style>
      </div>
    ))}
  </>
)

function CommunityFeed() {
  const [showPublisher, setShowPublisher] = useState(false)
  const { state: globalState } = useContext(GlobalStoreContext)
  const [rawDatas, setRawDatas] = useState<RawData[]>([])
  const [behotTime, setBehotTime] = useState(0)
  const [loading, setLoading] = useState(false)
  const [comments, setComments] = useState<string[]>([])
  const my_user_id = globalState?.userData?.user_id || ''
  useEffect(() => {
    const params = {
      tt_from: 'tab',
      category: 'motor_car_cmg',
      count: 8,
      impression_info: {
        page_id: 'page_forum_tab',
        sub_tab: 'motor_car_cmg',
      },
      motor_feed_extra_params: {
        new_feed: true,
        feed_type: 0,
        channel_id: 79290584491,
        actions: false,
        refresh_num: 1,
        loadmore_num: 0,
        from_page_id: 'page_forum_tab',
      },
      min_behot_time: (new Date().getTime() / 1000).toFixed(0),
      user_id: my_user_id,
      source: 'pc',
    }
    setLoading(true)
    fetch(
      getUrl(
        `/motor/stream_entrance/get_feed/v46/?${serializeObject({
          ...params,
          ...publicParams,
        })}`
      )
    )
      .then((json) => {
        setComments(
          json.data?.map((e: { unique_id_str: string }) => e?.unique_id_str) ||
            []
        )
        setBehotTime(
          json.data?.[json.data.length - 1]?.info?.behot_time || behotTime
        )
        setRawDatas(json.data)
        setLoading(false)
      })
      .catch((e) => {
        setLoading(false)
      })
  }, [])

  const loadMore = () => {
    const params = {
      tt_from: 'pre_load_more',
      category: 'motor_car_cmg',
      count: 8,

      motor_feed_extra_params: {
        new_feed: true,
        feed_type: 0,
        channel_id: 79290584491,
        actions: false,
        refresh_num: 1,
        loadmore_num: 0,
        from_page_id: 'page_forum_tab',
      },

      max_behot_time: behotTime,
      user_id: my_user_id,
      source: 'pc',
    }
    setLoading(true)
    fetch(
      getUrl(
        `/motor/stream_entrance/get_feed/v46/?${serializeObject({
          ...params,
          ...publicParams,
        })}`
      )
    )
      .then((json) => {
        setBehotTime(
          json.data?.[json.data.length - 1]?.info?.behot_time || behotTime
        )
        const filtered =
          json.data?.filter((e: { unique_id_str: string }) =>
            comments.every((comment) => comment !== e?.unique_id_str)
          ) || []
        setComments(
          comments.concat(
            filtered.map((e: { unique_id_str: string }) => e?.unique_id_str)
          )
        )

        setRawDatas(rawDatas.concat(filtered))
        setLoading(false)
      })
      .catch((e) => {
        setLoading(false)
      })
  }
  const handleTogglePublisher = useLoginCheckCallback(
    useCallback(() => {
      setShowPublisher(!showPublisher)
      sendTeaCommEvent('click_forum_home_post')
    }, [showPublisher]),
    useMemo(() => {
      return {
        enter_method: 'publish',
      }
    }, [])
  )

  const handlePublish = async (props: IPB) => {
    const { isTimer } = props

    if (!isTimer) {
      const user_id = globalState?.userData?.user_id
      if (!user_id) {
        return
      }
      const newData = await mockNewCard({ ...props, user_id })
      setRawDatas([newData as any, ...rawDatas])
    }

    setShowPublisher(false)
  }

  const handleDelete = useCallback(
    (gid: string) => {
      setRawDatas(rawDatas.filter((ele) => ele.unique_id_str !== gid))
    },
    [rawDatas]
  )

  return (
    <FeedContext.Provider
      value={{
        onDeletePost: handleDelete,
      }}
    >
      <div className="community-home-feed">
        <div className="feed-header">
          <div className="title">大家都在聊...</div>
          <Button
            type="new_primary"
            className="publish-button"
            onClick={handleTogglePublisher}
          >
            <>
              <img src={publish_icon} className="publish-icon" />
              <span className="publish-button-text">发布</span>
            </>
          </Button>
        </div>
        <Modal
          visible={showPublisher}
          onClose={handleTogglePublisher}
          className="publisher-modal"
          closable={true}
          CloseIcon={CloseIconForPublisher}
        >
          <Publisher onPublish={handlePublish} />
        </Modal>
        <ScrollLoader loadMoreHandler={loadMore} loading={loading} end={false}>
          {renderCards(rawDatas)}
        </ScrollLoader>
        {loading ? <Loading /> : null}

        <style jsx>
          {`
            .community-home-feed {
              margin-top: 78px;
              position: relative;
            }
            .feed-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 64px;
              padding-bottom: 8px;
              padding-top: 8px;
              position: sticky;
              top: 0;
              z-index: 1;
              background-color: #f7f8fc;
            }

            .title {
              font-size: 24px;
              line-height: 36px;
              color: #1f2129;
              font-weight: 500;
            }
            :global(.community-home-feed .publish-button) {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 120px;
              height: 48px;
              border-radius: 2px;
            }

            :global(.publisher-modal) {
              z-index: 1000 !important;
            }

            /* 
              注意portal会影响css后代选择器 不可通过设置关系选择器来增加权重 因而直接使用了important
              TODO: 待优化。
            */
            :global(.publisher-modal .modal-body) {
              padding: 0 !important;
              overflow-y: visible !important;
              overflow: visible !important;
            }
            :global(.publisher-modal .modal-container) {
              overflow-y: visible !important;
              overflow: visible !important;
            }
            .publish-icon {
              width: 20px;
              height: 20px;
              object-fit: contain;
              object-position: center;
              margin-right: 4px;
            }
            .publish-button-text {
              font-size: 16px;
              font-weight: 500;
              line-height: 22px;
              color: #1f2129;
            }
          `}
        </style>
      </div>
    </FeedContext.Provider>
  )
}

export default React.memo(CommunityFeed)
